// extracted by mini-css-extract-plugin
module.exports = {"container":"b1ddd01198--container--zacmQ","about-coworking-container":"b1ddd01198--about-coworking-container--ttQI_","logo-container":"b1ddd01198--logo-container--_EHZT"};